import { DataPoint } from "@suse-o11y/data-point";

import type { Metric } from "~/models/metric";

interface RawRangeMatrix {
	metric: Metric;

	/**
	 * Should be mutable Arrays to prevent from passing the resulting value back to {@link RangeMatrix.fromUnix}.
	 */
	values: Array<Array<null | string | number>>;
}

function fromUnix({ metric, values }: RawRangeMatrix): RangeMatrix {
	const points = values.flatMap((tuple) => {
		const point = DataPoint.fromUnix(tuple);

		return point ? [point] : [];
	});

	return { values: points, metric };
}

const RangeMatrix = { fromUnix };

interface RangeMatrix {
	readonly values: ReadonlyArray<readonly [timestamp: number, value: null | number]>;
	readonly metric: Metric;
}

export { RangeMatrix };
